export default __webpack_public_path__ + "static/caseStudy3-us-20da03953813b06f2edba3c7d27636d3.webp";